export const formatDateAAAAMMJJ = (timestamp:number) => {
    const date = new Date(timestamp);
    const year = date.getFullYear(); // Récupère l'année sur 4 chiffres
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Récupère le mois (0-11) et ajoute un zéro devant si nécessaire
    const day = String(date.getDate()).padStart(2, '0'); // Récupère le jour et ajoute un zéro devant si nécessaire
  
    return `${year}${month}${day}`;
  };